import { gql } from '@apollo/client';

import { DepositorFields } from '../escrow/escrowDepositor.fragment';
import { BeneficiaryFields } from '../beneficiary/beneficiary.fragment';
import { EscrowInvitationFields } from '../escrow/escrowInvitation.fragment';
import { EscrowAgreementFields } from '../escrow/escrowAgreement.fragment';
import { EscrowTerminationFields } from '../escrow/escrowTermination.fragment';

import { SaasEscrowBaseFields, SaasEscrowPolicyFields } from './saasEscrow.fragment';

export * from './saasEscrow.query.generated';

export const SAAS_ESCROW = gql`
  ${SaasEscrowBaseFields}
  ${SaasEscrowPolicyFields}
  ${DepositorFields}
  ${BeneficiaryFields}
  ${EscrowInvitationFields}
  ${EscrowAgreementFields}
  ${EscrowTerminationFields}
  query saasEscrow($saasEscrowId: ID!) {
    saasEscrow(saasEscrowId: $saasEscrowId) {
      ...SaasEscrowBaseFields
      activationNotification
      agreement {
        ...EscrowAgreementFields
      }
      agreementSettingsConfigured
      assetVersionsLimit
      currentCompanyRole
      beneficiaryConfigured
      beneficiarySharedInformation
      beneficiaryActivityNotification
      beneficiaryDisruptionNotification
      beneficiaryDisruptionNotificationGracePeriod
      depositorActivityNotification
      depositorDisruptionNotification
      depositorDisruptionNotificationGracePeriod
      depositorConfigured
      depositActivity
      depositStatus
      escrowTermination {
        ...EscrowTerminationFields
      }
      startedBy
      depositor {
        ...DepositorFields
      }
      beneficiary {
        ...BeneficiaryFields
      }
      escrowInvitation {
        ...EscrowInvitationFields
      }
      policy {
        ...SaasEscrowPolicyFields
      }
      reportsEnabled
      requiredContentTypes
      startedBy
      storageRegion
      app {
        id
        name
        logoUrl
        owned
        ownerName
        ownerWebsite
      }
    }
  }
`;
